import type { ComboButtonProps } from '@/dsComponents/buttons/types';
import type { LabelValue } from '@/types/common';

export enum FilterCategoryType {
	DATE = 'date',
	DATE_RANGE = 'dateRange',
	SELECT = 'select',
	BOOLEAN = 'boolean',
}

export interface DateRangeValue {
	from: string | null;
	to: string | null;
}

export interface FilterOption {
	id: string;
	label: string;
	icon?: string;
	count?: number;
	disabled?: boolean;
}

export interface FilterValue {
	id: string;
	label: string;
	checked: boolean;
	color?: string;
	count?: number;
	icon?: string;
	iconColor?: string;
	labelColor?: string;
	disabled?: boolean;
}

export interface FilterCategoryExtraSection {
	categoryId: string;
	label: string;
	icon?: string;
}

export interface FilterCategoryCustomValue {
	placeholder?: string;
	formatLabel: (value: number) => string;
}

export interface FilterCategory {
	id: string;
	label: string;
	icon?: string;
	values: FilterValue[];
	group?: string;
	type?: FilterCategoryType;
	multiSelect?: boolean;
	searchable?: boolean;
	canBeRemoved?: boolean;
	searchPlaceholder?: string;
	dateConfig?: {
		minDate?: Date;
		maxDate?: Date;
		format?: string;
	};
	extraSection?: FilterCategoryExtraSection;
	customValue?: FilterCategoryCustomValue;
}

export interface ActiveFilter {
	categoryId: string;
	categoryLabel: string;
	categoryIcon?: string;
	type?: FilterCategoryType;
	selectedOptions?: LabelValue[];
	options?: FilterOption[];
	dateValue?: string;
	dateRangeValue?: DateRangeValue;
	dateConfig?: {
		minDate?: Date;
		maxDate?: Date;
		format?: string;
	};
	booleanValue?: boolean;
	searchable?: boolean;
	searchPlaceholder?: string;
	multiSelect?: boolean;
	defaultValue?: LabelValue;
	width?: string;
	canBeRemoved?: boolean;
	// Holds a formatter function: only injected at render time from the category, never persisted
	customValue?: FilterCategoryCustomValue;
}

export interface FilterDropdownProps {
	categories: FilterCategory[];
	modelValue: ActiveFilter[];
	placeholder?: string;
	maxTagsVisible?: number;
	booleanTagButtons?: FilterBooleanTagButton[];
	trailingTagCategoryIds?: string[];
}

type FilterBooleanTagButtonBaseProps = Pick<
	ComboButtonProps,
	| 'iconLeft'
	| 'iconRight'
	| 'variant'
	| 'active'
	| 'placeholder'
	| 'loadingLeft'
	| 'showPlusWhenInactive'
>;

export interface FilterBooleanTagButton
	extends FilterBooleanTagButtonBaseProps {
	id: string;
	label: string;
	onClick?: () => void;
	onRight?: () => void;
}
